import {
  CONNECT_YOTPO_REQUEST,
  CONNECT_YOTPO_SUCCESS,
  CONNECT_YOTPO_FAILURE,
  DISCONNECT_YOTPO_REQUEST,
  DISCONNECT_YOTPO_SUCCESS,
  DISCONNECT_YOTPO_FAILURE
} from '../actions/yotpoActions';

const initialState = {
  yotpoData: null,
  saving: false,
  error: null,
  validationErrors: null,
  lastMessage: null
};

const yotpoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONNECT_YOTPO_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        validationErrors: null,
        lastMessage: null
      };

    case CONNECT_YOTPO_SUCCESS:
      return {
        ...state,
        saving: false,
        yotpoData: action.payload.data || state.yotpoData,
        error: null,
        validationErrors: null,
        lastMessage: action.payload.message || 'Yotpo connected successfully'
      };

    case CONNECT_YOTPO_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.payload,
        validationErrors: action.payload.validationErrors || null,
        lastMessage: null
      };

    case DISCONNECT_YOTPO_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        lastMessage: null
      };

    case DISCONNECT_YOTPO_SUCCESS:
      return {
        ...state,
        saving: false,
        lastMessage: action.payload?.message || 'Disconnected successfully'
      };

    case DISCONNECT_YOTPO_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.error || 'Failed to disconnect',
        lastMessage: null
      };

    default:
      return state;
  }
};

export default yotpoReducer;

